import { render } from "./BlogSummary.vue?vue&type=template&id=45643889"
import script from "./BlogSummary.vue?vue&type=script&lang=js"
export * from "./BlogSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__